import { SxProps } from '@mui/system';
import { Theme } from 'theme';

export const layoutErrorStyle: SxProps<Theme> = theme => ({
	paddingTop: 0,
	paddingBottom: 4,
	backgroundColor: theme.palette.background.default,
});
